export var BaseToastVariant;
(function (BaseToastVariant) {
    BaseToastVariant["Info"] = "info";
    BaseToastVariant["Error"] = "error";
    BaseToastVariant["Success"] = "success";
    BaseToastVariant["General"] = "general";
})(BaseToastVariant || (BaseToastVariant = {}));
//# sourceMappingURL=types.js.map